
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({
  name: 'NSwitch'
})
export default class NSwitch extends Vue {
  @Prop({ type: Boolean, default: false })
  disabled?: boolean;

  @Prop({ type: [String, Number], default: '' })
  label?: string | number;

  @Prop({ type: [String, Number, Boolean], default: false })
  modelValue!: boolean;

  focused = false;

  handleChange() {
    if (this.disabled) return;
    const newValue = !this.modelValue;
    this.$emit('update:modelValue', newValue);
  }
}
